import { render, staticRenderFns } from "./SipCallDropdown.vue?vue&type=template&id=4f219b36"
import script from "./SipCallDropdown.vue?vue&type=script&lang=js"
export * from "./SipCallDropdown.vue?vue&type=script&lang=js"
import style0 from "./SipCallDropdown.vue?vue&type=style&index=0&id=4f219b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports